import * as types from '../mutation-types'
import { create_rate } from '@/api/rate'
export const state = {
    rate: {},
    loading: false,
}

export const getters = {
    rate: state => state.rate,
    loading: state => state.loading,
}

export const mutations = {
    [types.RATE](state, payload) {
        state.loading = true
    },
    [types.RATE_SUCCESS](state, payload) {
        state.loading = false;
        state.rate = payload;
    },
    [types.RATE_FAIL](state, payload) {
        state.loading = false;
        state.rate = {};
    }
}
export const actions = {
    async  submitRate({ commit, getters }, payload) {
        commit(types.RATE);
        try {
            let data = await create_rate(payload);
            commit(types.RATE_SUCCESS, data)
        } catch (error) {
            commit(types.RATE_FAIL)
        }
    },

}
